import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import Table from '@/components/ui/tables/Table';
import { DateRangeFilter } from '@/components/ui/filters/DateRangeFilter';
import { useMyAttendance } from '@/hooks/attendance/myAttendance/useMyAttendance';
import { PermissionGuard } from '@/components/layout';
import { formatDateToYYYYMMDD, getMinDateByMonths } from '@/utils';
import { useTranslation } from '@/i18n';


export const MyAttendance: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    filters,
    setFilters,
    defaultFrom,
    defaultTo,
    openRegisterPanel,
    data,
    totalRecords,
    isLoading,
    page,
    pageSize,
    setPage,
    setPageSize,
    onSearch,
    onSortChange,
    columns,
    actions,
  } = useMyAttendance();

  return (
    <PageLayout>
      <div className="flex flex-col gap-6" data-testid="my-attendance-page">
        <div>
          <PermissionGuard action="create">
            <PrimaryButton
              onClick={openRegisterPanel}
              iconLeft={<IconScout name="plus" />}
            >
              {translate('attendance:create')}
            </PrimaryButton>
          </PermissionGuard>
        </div>
        <div className="flex flex-wrap gap-3 items-center">
          <DateRangeFilter
            value={{ from: filters.from, to: filters.to }}
            defaultValue={{ from: defaultFrom, to: defaultTo }}
            onChange={(range) => {
              setFilters((prev) => ({ ...prev, from: range.from, to: range.to }));
            }}
            maxDate={formatDateToYYYYMMDD(new Date())}
            minDate={getMinDateByMonths()}
            closeOnComplete
          />
        </div>
        <Table
          columns={columns}
          data={data}
          totalRows={totalRecords}
          isLoading={isLoading}
          searchable={true}
          onSearch={onSearch}
          serverSideSort
          onSortChange={onSortChange}
          pagination={{
            page,
            pageSize,
            total: totalRecords,
            onChange: setPage,
            onPageSizeChange: setPageSize,
          }}
          initialSort={{ key: 'fecha', direction: 'desc' }}
          data-testid="table-mis-asistencias"
          actions={actions}
        />
      </div>
    </PageLayout>
  );
};

export default MyAttendance;
